import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";

const PreviewHero = () => {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggleSound = () => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = !v.muted;
    setMuted(v.muted);
    if (!v.muted) {
      v.currentTime = 0;
      v.play();
    }
  };

  return (
    <section
      id="home"
      className="hero-nuance relative w-full overflow-hidden lg:h-[calc(100vh-72px)] lg:min-h-[600px]"
      data-testid="preview-hero-section"
    >

      <div className="relative flex h-full items-end">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-10 px-5 pb-14 pt-14 sm:px-8 sm:pb-20 sm:pt-20 lg:flex-row lg:items-end lg:justify-between lg:pt-0">
          <div>
            <h1
              className="hero-fade font-display text-4xl font-bold leading-[1.02] tracking-tight text-[#852936] sm:text-5xl md:text-6xl lg:text-7xl"
              style={{ animationDelay: "0.15s" }}
            >
              Coaching.
              <br />
              Workshops.
              <br />
              Undervisning.
            </h1>
            <p
              className="hero-fade mt-6 max-w-lg text-lg font-light leading-relaxed text-[#111827]/72 sm:mt-8 sm:text-xl"
              style={{ animationDelay: "0.3s" }}
              data-testid="preview-hero-subheading"
            >
              Jeg udvikler mennesker og fællesskaber gennem coaching, workshops og undervisning inden for
              erhvervslivet, sport, kreative miljøer og i livet generelt.
            </p>
            <div className="hero-fade mt-9 flex flex-wrap items-center gap-4" style={{ animationDelay: "0.4s" }}>
              <Link
                to="/kontakt"
                className="inline-flex items-center rounded-full bg-[#852936] px-8 py-4 text-base font-semibold text-white transition-transform duration-300 hover:scale-[1.04] preview-shadow-soft"
                data-testid="preview-hero-cta"
              >
                Kontakt
              </Link>
              <Link
                to="/om"
                className="inline-flex items-center gap-2 rounded-full border border-[#852936]/40 px-8 py-4 text-base font-medium text-[#852936] transition-colors duration-300 hover:border-[#852936]"
              >
                Læs mere
              </Link>
            </div>
          </div>

          <div
            className="hero-fade relative w-full max-w-[300px] flex-shrink-0 overflow-hidden rounded-3xl bg-black preview-shadow-lift sm:max-w-[340px] lg:mb-16 lg:max-w-[400px]"
            style={{ animationDelay: "0.5s" }}
            data-testid="preview-hero-video-wrap"
          >
            <video
              ref={videoRef}
              autoPlay
              muted
              playsInline
              preload="metadata"
              poster="/media/forside-klip-2-poster.jpg"
              className="aspect-[5/4] h-auto w-full object-cover"
              data-testid="preview-hero-video"
            >
              <source src="/media/forside-klip-2.mp4" type="video/mp4" />
            </video>
            <button
              type="button"
              onClick={toggleSound}
              className="absolute bottom-4 left-4 inline-flex items-center gap-2 rounded-full bg-white/90 px-4 py-2 text-[13px] font-semibold text-[#111827] transition-transform duration-300 hover:scale-[1.04]"
              data-testid="preview-hero-video-sound"
            >
              {muted ? (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-3.5 w-3.5"><path d="M11 5L6 9H2v6h4l5 4V5z" /><line x1="23" y1="9" x2="17" y2="15" /><line x1="17" y1="9" x2="23" y2="15" /></svg>
              ) : (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-3.5 w-3.5"><path d="M11 5L6 9H2v6h4l5 4V5z" /><path d="M15.5 8.5a5 5 0 010 7" /><path d="M19 5a10 10 0 010 14" /></svg>
              )}
              {muted ? "Lyd til" : "Lyd fra"}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PreviewHero;
